/**
 * GET `admin/clients/:id/usage` — расход клиники по дням за период
 * (по умолчанию бэк берёт текущий месяц). Дни без активности не приходят.
 */

import {apiEnabled, http} from '@services/utils';

import {mockClinicUsage} from '../mocks';
import {asNum, asObj, asStr, toRateCard, toTotals} from '../toUsage';
import type {ClinicUsage} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getClinicUsage = async (
  clinicId: string,
  from: string,
  to: string,
): Promise<ClinicUsage> => {
  if (!apiEnabled) {
    await sleep(250);
    return mockClinicUsage(from, to);
  }
  const r = asObj(
    await http(`admin/clients/${encodeURIComponent(clinicId)}/usage`, {
      params: {dateFrom: from, dateTo: to},
      skipCaseConversion: true,
    }),
  );
  return {
    dateFrom: asStr(r.dateFrom) || from,
    dateTo: asStr(r.dateTo) || to,
    days: (Array.isArray(r.days) ? r.days : []).map((d) => {
      const x = asObj(d);
      return {day: asStr(x.day), totals: toTotals(x.totals)};
    }),
    totals: toTotals(r.totals),
    estimatedCostTiyin: asNum(r.estimatedCostTiyin),
    rateCard: toRateCard(r.rateCard),
  };
};
